import OutputMultiLineGraph from '../Visualisations/outputs/OutputMultiLineGraph'

// AI-CONTEXT: See docs/features/livereport-widgets-housevisits-personas.md
// Shared bar-chart visualisation for "Personas by route". Used by both
// `DashboardPersonaRoutesCard` and the upcoming `PersonasRoutesWidget`.
// Dashboard card doesn't have a click-to-filter behaviour today but we
// still expose `onItemClick` so a future change has a single seam.

/**
 * @typedef {object} PersonasRoutesDatum
 * @property {string} name - Route title used as the bar label
 * @property {string} [routeId] - Stable route ID (forwarded to onItemClick)
 * @property {{ total: number }} value - Bar value
 */

/**
 * @param {object} props
 * @param {Array<PersonasRoutesDatum>} props.data
 * @param {string} props.color
 * @param {string|number} [props.height='100%']
 * @param {(item: PersonasRoutesDatum) => void} [props.onItemClick]
 * @returns {JSX.Element}
 */
const PersonasRoutesVisualization = ({
    data,
    color,
    height = '100%',
    onItemClick,
}) => {
    const bars = [{ Title: 'value', Color: color }]

    return (
        <OutputMultiLineGraph
            data={data}
            tableCategoryLabel="Route"
            tableValueLabel="Aantal"
            graphType="bar"
            outputs={bars}
            color={color}
            growth={{ average: 0, perOutput: {} }}
            height={height}
            displayLegend={false}
            onBarClick={onItemClick ? (payload) => onItemClick(payload) : undefined}
        />
    )
}

export default PersonasRoutesVisualization
